import { useTranslation } from 'react-i18next';

import { cn } from '@workspace/ui/lib/utils';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import Spinner from '~/components/isolated/Spinner';
import { useIntercom } from '~/hooks/useIntercom';
import { AnalyticsEvent, analyticsService } from '~/services/analytics';

/**
 * Floating support launcher pinned to the bottom-right corner of the desktop
 * layout. Intercom boots with `hide_default_launcher`, so the messenger needs
 * a permanently visible entry point outside the footer.
 */
export const SupportFloatingButton = () => {
  const { t } = useTranslation();
  const { openMessenger, isOpening } = useIntercom();

  if (!company.hasFloatingSupportButton) return null;

  const handleClick = () => {
    analyticsService.track(AnalyticsEvent.CONTACT_SUPPORT_BUTTON_CLICKED, {
      from: 'floating_button',
    });
    openMessenger();
  };

  return (
    <button
      type="button"
      aria-label={t('contactSupport')}
      disabled={isOpening}
      onClick={handleClick}
      className={cn(
        'fixed right-8 bottom-8 z-[22] flex h-14 w-14 cursor-pointer items-center justify-center',
        'rounded-full border-none bg-navigation-action-brand text-navigation-text-in-button',
        'shadow-[0_8px_24px_rgba(0,0,0,0.16)] transition-colors duration-300',
        'hover:bg-navigation-action-brand-hover disabled:cursor-default',
      )}
    >
      {isOpening ? (
        <Spinner variant="white" />
      ) : (
        <Icon type="support-3.1" size={24} />
      )}
    </button>
  );
};
